import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, finalize, Subject, takeUntil } from 'rxjs';
import { FormGroup } from '@angular/forms'; 
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DailyLogService } from '../daily-log.service';
import { DialogRef } from '@angular/cdk/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as htmlEntities from 'html-entities'
import { CommonService } from 'src/app/services/common.service';
interface UploadedFile {
  file: File;
  preview: string;
  fileId?: string;
  fileName?: string;
  FileType?: string;
}

@Component({
  selector: 'app-comment-daily-log',
  templateUrl: './comment-daily-log.component.html',
  styleUrls: ['./comment-daily-log.component.scss']
})
export class CommentDailyLogComponent implements OnInit {
  contractor_account_id: string
   selected: boolean[] = [];
  allLogs = [];
  formDailyLog: FormGroup;
  projectDetail: any;
  userData: any;
  type: string;
  filesSubj = new BehaviorSubject<File[]>(null);
  @ViewChild('fileInput') fileInput;
  project_id: string
  loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  ngUnsubscribe = new Subject();
   isFranchisee: boolean = false;
  
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private snackbarService: SnackbarService, private dlService: DailyLogService, private router: Router, 
    @Inject(MAT_DIALOG_DATA) private data: any,  private commonService: CommonService,
    private dialogRef: MatDialogRef<CommentDailyLogComponent>) {
        this.projectDetail = JSON.parse(sessionStorage.getItem('project_detail'));
    this.userData = JSON.parse(sessionStorage.getItem('userdata'));
  }

  ngOnInit(): void {
    this.project_id = this.data.project_id;
    console.log(this.project_id)
    console.log(this.data)
  this.type = this.data?.type
 this.isFranchisee = this.commonService?.isFranchisee;
 this.contractor_account_id = this.isFranchisee ? this.commonService.franchiseeContractor_id : this.userData?.subcontractor_id;
  this.buildFormDailyLog()
  }
  getDailyLogs() {
    console.log("pro det", this.projectDetail)
    this.dlService.getDailyLogs(this.project_id, this.contractor_account_id).subscribe(data => {
      console.log(data);
      this.allLogs = data?.logs.sort((a, b) => {
        const dateA = new Date(a?.created_at ?? "").getTime();
        const dateB = new Date(b?.created_at ?? "").getTime();
        return dateB - dateA;
      });
      this.selected = this.allLogs.map(() => false);
    })
  }
  
buildFormDailyLog() {
  this.formDailyLog = this.fb.group({
    log_description: ['', [Validators.required]],
    daily_log_uploads_document: this.fb.array([])

  });
}


  maxLengthValidator(arg0: number): any | string {
    throw new Error('Method not implemented.');
  }
    noWhitespaceValidator: ValidatorFn = (control: AbstractControl) => {
    const value = control.value ? control.value.trim() : '';
    return value.length === 0 ? { whitespace: true } : null;
  };
   saveFormDailyLog() {
    console.log(this.formDailyLog)
    this.formDailyLog.markAsTouched();
    // Check if the form is valid
    if (!this.formDailyLog.invalid) {
      // Prevent multiple submissions if the request is already in progress
      if (this.loadingSubject.value) {
        return;
      }


      // this.loadingSubject.next(true);
      const comment = this.formDailyLog.value.log_description;
      const encodedComment = htmlEntities.encode(comment);

      // Build the request object as per the required payload structure
      const req = {
        daily_log_id: this.data.daily_log_id,  
        project_id: this.project_id,  
        created_by_user_id: this.userData.subcontractor_id,  
        comment: encodedComment,
        commented_by_type:"CS",  
        time: new Date().toLocaleString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true  
        }),
      };
      // Make the save API call
      this.dlService.addComment(req).pipe(
        finalize(() => {
          // Reset the loading state and close the dialog after the request is complete
          this.loadingSubject.next(false);
          this.dialogRef.close(true);
        })
      ).subscribe(
        response => {
          // const data = response['data'];
          const data = response;
          console.log("respond form", data)
          if (data['status'] === 200 && data['message']) {
            this.openSnackbar(data['message']);
            this.dialogRef.close();
          }
        },
        error => {
          console.log(error);  // Log errors if any
        }
      );
    }
  }
  
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

    goBack() {
    window.history.back()
  }

  filesList: UploadedFile[] = [];

 onFileChange(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (!input.files?.length) return;

  const selectedFiles = Array.from(input.files);
  const filesToUpload: UploadedFile[] = [];
  let filesRead = 0;

  selectedFiles.forEach((file: File) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const filePreview = e.target?.result as string;

      const newFile: UploadedFile = {
        file,
        preview: filePreview,
        fileId: '',
        fileName: '',
        FileType: '',
      };

      this.filesList.push(newFile);
      filesToUpload.push(newFile);
      filesRead++;

      // Upload after all previews are ready
      if (filesRead === selectedFiles.length) {
        this.uploadMultipleFiles(filesToUpload);
      }
    };

    reader.readAsDataURL(file);
  });

  input.value = ''; // Reset file input to allow reselecting same files
}

uploadMultipleFiles(uploadedFiles: UploadedFile[]): void {
  if (this.loadingSubject.value) return;

  this.loadingSubject.next(true);
  const formData = new FormData();

  uploadedFiles.forEach(uploaded => {
    formData.append('myFile', uploaded.file);
  });

  formData.append('reference_types', 'briefing_form');

  this.dlService.multipleUploadDoc(formData)
    .pipe(
      takeUntil(this.ngUnsubscribe),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe((data: any) => {
      if (data?.status === 200 && data.filedata?.length) {
        data.filedata.forEach((fileResult: any, index: number) => {
          const response = fileResult?.uploadedFile?.[0];
          if (response) {
            const classifiedType = this.classifyFileType(response);
            uploadedFiles[index].fileId = response.file_id;
            uploadedFiles[index].fileName = response.file_name;
            uploadedFiles[index].FileType = response.file_mime_type; // Store for reuse if needed
            this.openSnackbar(response.message || 'File uploaded');

            console.log(`File: ${response.file_name}, MIME: ${response.file_mime_type} → Classified: ${classifiedType}`);
          }
        });
      } else {
        this.openSnackbar(data?.message || 'Upload failed');
        uploadedFiles.forEach(file => this.removeFileByReference(file));
      }
    });
}

classifyFileType(file) {
  const mime = (file.file_mime_type || '').toLowerCase();

  if (mime === 'image/jpeg' || mime === 'image/jpg' || mime === 'image/png') {
    return 'photo';
  } else if (mime === 'video/mp4' || mime === 'video/quicktime') {
    return 'video';
  } else {
    return 'documents';
  }
}

  removeFile(index: number) {
    if (this.loadingSubject.value) return;

    this.loadingSubject.next(true);
    const removed = this.filesList[index];
    this.filesList.splice(index, 1);

    if (removed?.fileId && removed?.fileName) {
      this.dlService.deleteAttachment(this.data.id, removed.fileId,).subscribe(() => {
        this.openSnackbar('File deleted successfully');
        this.loadingSubject.next(false)
      }, () => {
        this.openSnackbar('Error deleting file');
        this.loadingSubject.next(false)
      });
    }
  }

  removeFileByReference(fileRef: UploadedFile) {
    this.filesList = this.filesList.filter(f => f !== fileRef);
  }

  isImage(file: UploadedFile): boolean {
    return file.file.type.startsWith('image/');
  }

  isVideo(file: UploadedFile): boolean {
    return file.file.type.startsWith('video/');
  }

  isDocument(file: UploadedFile): boolean {
    return file.FileType == 'documents';
  }
   saveFile() {
    console.log(this.filesList, 'list')
    console.log(this.data, 'data')
    const payload = {
      daily_log_id: this.data.daily_log_id,
      user_id: this.data.user_id,
      daily_log_uploads: this.filesList.map(file => {
      const type = this.classifyFileType({ file_mime_type: file.FileType }); 
      return {
        file_id: file.fileId,
        file_name: file.fileName,
        daily_log_upload_type: type
      };})
    };
    console.log(payload)
    this.dlService.uploadImage(payload)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((data:any) => {
        console.log(data)
        if (data?.status === 201) {
          if (data) {
            this.openSnackbar(data.message || 'File uploaded');
            this.dialogRef.close(true)
          }
        } else {
          this.openSnackbar(data?.message || 'Upload failed');
          this.dialogRef.close(true)
        }
      });
  }
}
